/* GIREA — global.js
   Menú móvil, drawer de carrito AJAX, barra de envío gratis,
   selector de variantes, barra sticky de compra y animaciones. */

(function () {
  'use strict';

  /* ---------- Utilidades ---------- */
  function formatMoney(cents) {
    var format = (window.GIREA && window.GIREA.moneyFormat) || '$ {{amount_no_decimals_with_comma_separator}}';
    var value = '';
    function delimit(number, thousands, decimal, precision) {
      var parts = (number / 100).toFixed(precision).split('.');
      var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return precision > 0 ? whole + decimal + parts[1] : whole;
    }
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = match ? match[1] : 'amount';
    switch (key) {
      case 'amount': value = delimit(cents, ',', '.', 2); break;
      case 'amount_no_decimals': value = delimit(cents, ',', '.', 0); break;
      case 'amount_with_comma_separator': value = delimit(cents, '.', ',', 2); break;
      case 'amount_no_decimals_with_comma_separator': value = delimit(cents, '.', ',', 0); break;
      default: value = delimit(cents, '.', ',', 0);
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  /* ---------- Animación de entrada ---------- */
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('in-view');
        observer.unobserve(entry.target);
      }
    });
  }, { rootMargin: '0px 0px -8% 0px' });
  document.querySelectorAll('.fade-up').forEach(function (el) { observer.observe(el); });

  /* ---------- Menú móvil ---------- */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-menu-open]')) document.body.classList.add('menu-open');
    if (e.target.closest('[data-menu-close]')) document.body.classList.remove('menu-open');
  });

  /* ---------- Carrito: drawer + AJAX ---------- */
  var drawer = document.getElementById('CartDrawer');

  function openDrawer() { if (drawer) { drawer.classList.add('open'); document.body.style.overflow = 'hidden'; } }
  function closeDrawer() { if (drawer) { drawer.classList.remove('open'); document.body.style.overflow = ''; } }

  function renderShippingBar(totalPrice) {
    var threshold = window.GIREA.freeShippingThreshold;
    document.querySelectorAll('[data-shipping-bar]').forEach(function (bar) {
      var label = bar.querySelector('[data-shipping-label]');
      var fill = bar.querySelector('[data-shipping-fill]');
      if (!threshold || threshold <= 0) { bar.hidden = true; return; }
      bar.hidden = false;
      var remaining = threshold - totalPrice;
      if (remaining > 0) {
        label.textContent = 'Te faltan ' + formatMoney(remaining) + ' para envío gratis';
        fill.style.width = Math.min(100, (totalPrice / threshold) * 100) + '%';
      } else {
        label.textContent = 'Tienes envío gratis';
        fill.style.width = '100%';
      }
    });
  }

  function renderCart(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.setAttribute('data-count', cart.item_count);
    });
    renderShippingBar(cart.total_price);
    document.querySelectorAll('[data-cart-subtotal]').forEach(function (el) {
      el.textContent = formatMoney(cart.total_price);
    });

    var container = drawer && drawer.querySelector('[data-cart-items]');
    if (!container) return;

    if (cart.item_count === 0) {
      container.innerHTML = '<div class="drawer__empty"><p>Tu carrito está vacío.</p><a class="link-underline" href="/collections/all">Explorar la colección</a></div>';
      return;
    }

    container.innerHTML = cart.items.map(function (item, index) {
      var image = item.image
        ? '<img src="' + item.image.replace(/(\.[^.]*)$/, '_160x$1') + '" alt="" loading="lazy" width="80" height="100">'
        : '';
      var variant = item.variant_title && item.variant_title !== 'Default Title'
        ? '<p class="cart-item__variant">' + item.variant_title + '</p>' : '';
      return (
        '<div class="cart-item" data-line="' + (index + 1) + '">' +
          '<div class="cart-item__media"><a href="' + item.url + '">' + image + '</a></div>' +
          '<div>' +
            '<p class="cart-item__title"><a href="' + item.url + '">' + item.product_title + '</a></p>' +
            variant +
            '<div class="qty">' +
              '<button type="button" data-qty-change="-1" aria-label="Disminuir">&minus;</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button type="button" data-qty-change="1" aria-label="Aumentar">+</button>' +
            '</div>' +
          '</div>' +
          '<div>' +
            '<p class="cart-item__price">' + formatMoney(item.final_line_price) + '</p>' +
            '<button type="button" class="cart-item__remove" data-qty-remove>Eliminar</button>' +
          '</div>' +
        '</div>'
      );
    }).join('');
  }

  function refreshCart() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(renderCart);
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]')) {
      e.preventDefault();
      refreshCart().then(openDrawer);
    }
    if (e.target.closest('[data-drawer-close]')) closeDrawer();

    var qtyBtn = e.target.closest('[data-qty-change], [data-qty-remove]');
    if (qtyBtn) {
      var row = qtyBtn.closest('.cart-item');
      var line = parseInt(row.getAttribute('data-line'), 10);
      var current = parseInt(row.querySelector('.qty span').textContent, 10);
      var quantity = qtyBtn.hasAttribute('data-qty-remove')
        ? 0
        : Math.max(0, current + parseInt(qtyBtn.getAttribute('data-qty-change'), 10));
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      }).then(function (r) { return r.json(); }).then(function (cart) {
        renderCart(cart);
        if (document.body.classList.contains('template-cart')) window.location.reload();
      });
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeDrawer(); document.body.classList.remove('menu-open'); }
  });

  /* Añadir al carrito por AJAX */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ajax-add]');
    if (!form) return;
    e.preventDefault();
    var button = form.querySelector('[type="submit"]');
    if (button) { button.setAttribute('disabled', ''); }
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
      .then(function (r) {
        if (!r.ok) throw new Error('add-error');
        return r.json();
      })
      .then(function () { return refreshCart(); })
      .then(openDrawer)
      .catch(function () { form.submit(); })
      .finally(function () { if (button) button.removeAttribute('disabled'); });
  });

  refreshCart();

  /* ---------- Selector de variantes en PDP ---------- */
  var pdp = document.querySelector('[data-product]');
  if (pdp) {
    var variantsEl = pdp.querySelector('[data-variants]');
    var variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
    var selects = pdp.querySelectorAll('[data-option-select]');
    var idInput = pdp.querySelector('input[name="id"]');
    var priceEls = document.querySelectorAll('[data-price]');
    var comparePriceEls = document.querySelectorAll('[data-compare-price]');
    var buyButtons = document.querySelectorAll('[data-buy-button]');

    function currentVariant() {
      var chosen = Array.prototype.map.call(selects, function (s) { return s.value; });
      return variants.find(function (v) {
        return chosen.every(function (value, i) { return v.options[i] === value; });
      });
    }

    function updateVariant() {
      var variant = currentVariant();
      if (!variant) return;
      if (idInput) idInput.value = variant.id;
      priceEls.forEach(function (el) { el.textContent = formatMoney(variant.price); });
      comparePriceEls.forEach(function (el) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          el.textContent = formatMoney(variant.compare_at_price);
          el.hidden = false;
        } else { el.hidden = true; }
      });
      buyButtons.forEach(function (btn) {
        if (variant.available) {
          btn.removeAttribute('disabled');
          btn.textContent = btn.getAttribute('data-label-add') || 'Agregar al carrito';
        } else {
          btn.setAttribute('disabled', '');
          btn.textContent = btn.getAttribute('data-label-soldout') || 'Agotado';
        }
      });
      if (history.replaceState && variant.id) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url.toString());
      }
    }

    selects.forEach(function (s) { s.addEventListener('change', updateVariant); });

    /* Barra sticky de compra en móvil */
    var stickyBar = document.querySelector('.sticky-atc');
    var mainButton = pdp.querySelector('[data-buy-button]');
    if (stickyBar && mainButton) {
      var stickyObserver = new IntersectionObserver(function (entries) {
        stickyBar.classList.toggle('visible', !entries[0].isIntersecting);
      });
      stickyObserver.observe(mainButton);
      var stickyBtn = stickyBar.querySelector('[data-sticky-add]');
      if (stickyBtn) {
        stickyBtn.addEventListener('click', function () {
          var form = pdp.querySelector('form[data-ajax-add]');
          if (form) {
            if (form.requestSubmit) form.requestSubmit();
            else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
          }
        });
      }
    }
  }

  /* ---------- Orden en colecciones ---------- */
  document.querySelectorAll('[data-sort-select]').forEach(function (select) {
    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      window.location.href = url.toString();
    });
  });
})();
